import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { PipesModule } from '@core/pipes/pipes.module';
import { AccountService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/icon/icon.component';
import { CSchool, IAccountStats, User } from 'lingo2-models';
import { takeUntil } from 'rxjs/operators';

interface IDetails {
  show: boolean;
  rate: number;
  count: number;
}

@Component({
  selector: 'app-rating',
  standalone: true,
  imports: [CommonModule, TranslateModule, IconComponent, PipesModule],
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss'],
})
export class RatingComponent extends ChangableComponent {
  @Input() public stats: IAccountStats | CSchool;
  @Input() public label: boolean;
  @Input() public reviewLabel = true;
  @Input() public user: User;
  @Input() public userId: string;

  constructor(
    protected cdr: ChangeDetectorRef,
    protected accountService: AccountService,
    private readonly router: Router,
  ) {
    super(cdr);
  }

  public get isSchool() {
    return this.stats instanceof CSchool;
  }

  public feedback(): void {
    if (this.user) {
      this.router.navigateByUrl(`/u/${this.user?.slug}/feedback`).catch();
    }

    if (this.userId) {
      this.accountService
        .getUserById(this.userId, 'LOAD_TIME')
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: (user) => {
            this.router.navigateByUrl(`/u/${user?.slug}/feedback`).catch();
            this.detectChanges();
          },
          error: (error) => {
            this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
          },
        });
    }
  }

  public get rating(): IDetails {
    if (this.stats instanceof CSchool) {
      return {
        show: !!this.stats.rating,
        rate: this.stats.rating || 0,
        count: this.stats.review_count || 0,
      };
    } else {
      return {
        show: !!this.stats?.reviews_rating,
        rate: this.stats?.reviews_rating ? this.stats?.reviews_rating : 0,
        count: this.stats?.reviews_count ? this.stats?.reviews_count : 0,
      };
    }
  }
}
